(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lanotec-industry-range"] && !Shopify.designMode) return;
  try {
    
if (!window.lanotecSizeDropdownInstalled) {
  window.lanotecSizeDropdownInstalled = true;
  document.addEventListener('change', function(event) {
    if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-family-size]')) return;
    const select = event.target;
    const card = select.closest('[data-lanotec-family]');
    const option = select.selectedOptions[0];
    if (!card || !option) return;
    card.querySelectorAll('[data-family-product-link], [data-family-image-link]').forEach(function(link) { link.href = option.value; });
    const imageLink = card.querySelector('[data-family-image-link]');
    let image = card.querySelector('.lanotec-family-photo');
    if (option.dataset.image && imageLink) {
      if (!image) { image = document.createElement('img'); image.className = 'lanotec-family-photo'; image.width = 650; image.height = 650; imageLink.appendChild(image); }
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = option.dataset.image;
      image.alt = option.dataset.title || '';
    }
    if (imageLink) imageLink.setAttribute('aria-label', option.dataset.title || '');
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lanotec-product-browser"] && !Shopify.designMode) return;
  try {
    
if (!window.lanotecProductBrowserInstalled) {
  window.lanotecProductBrowserInstalled = true;
  function updateCard(card) {
    if (!card) return;
    const imageLink = card.querySelector('[data-browse-image-link]');
    const productLink = card.querySelector('[data-browse-product-link]');
    if (!card.lanotecCover) {
      const original = card.querySelector('.lp-photo');
      card.lanotecCover = { image: original?.cloneNode(true), label: imageLink.getAttribute('aria-label') };
    }
    const option = card.querySelector('[data-browse-size]').selectedOptions[0];
    if (!option?.value) {
      const image = card.querySelector('.lp-photo');
      if (card.lanotecCover.image) {
        const cover = card.lanotecCover.image.cloneNode(true);
        if (image) image.replaceWith(cover); else imageLink.appendChild(cover);
      } else if (image) image.remove();
      imageLink.href = '#' + card.querySelector('[data-browse-size]').id;
      imageLink.setAttribute('aria-label', card.lanotecCover.label || '');
      productLink.href = imageLink.href;
      productLink.setAttribute('aria-disabled', 'true');
      productLink.querySelector('[data-product-button-label]').textContent = productLink.dataset.selectLabel;
      const saleMode = card.closest('[data-lanotec-browser]').querySelector('[data-browse-mode]').value === 'sale';
      card.querySelector('[data-sale-badge]').hidden = !saleMode;
      return;
    }
    productLink.removeAttribute('aria-disabled');
    productLink.querySelector('[data-product-button-label]').textContent = productLink.dataset.productLabel;
    card.querySelectorAll('[data-browse-product-link], [data-browse-image-link]').forEach(link => { link.href = option.value; });
    let image = card.querySelector('.lp-photo');
    if (option.dataset.image) {
      if (!image) { image = document.createElement('img'); image.className = 'lp-photo'; image.width = 650; image.height = 650; imageLink.appendChild(image); }
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = option.dataset.image;
      image.alt = option.dataset.title || '';
      image.hidden = false;
    } else if (image) image.hidden = true;
    imageLink.setAttribute('aria-label', option.dataset.title || '');
    card.querySelector('[data-sale-badge]').hidden = option.dataset.sale !== 'true';
  }
  function updateBrowser(root) {
    const mode = root.querySelector('[data-browse-mode]').value;
    const category = mode === 'industry' ? root.querySelector('[data-browse-industry]').value : root.querySelector('[data-browse-type]').value;
    root.querySelector('[data-industry-control]').hidden = mode !== 'industry';
    root.querySelector('[data-type-control]').hidden = mode !== 'type';
    let visible = 0;
    root.querySelectorAll('[data-browse-card]').forEach(card => {
      const select = card.querySelector('[data-browse-size]');
      const options = Array.from(select.options);
      options.forEach(option => { option.hidden = Boolean(option.value) && mode === 'sale' && option.dataset.sale !== 'true'; option.disabled = option.hidden; });
      const eligible = options.filter(option => option.value && !option.disabled);
      if (select.selectedOptions[0]?.disabled) select.value = '';
      updateCard(card);
      const matches = mode === 'sale' ? eligible.length > 0 : mode === 'all' || (mode === 'industry' ? card.dataset.industries : card.dataset.types).split(/\s+/).includes(category);
      card.hidden = !matches;
      if (matches) visible++;
    });
    const status = root.querySelector('[data-browse-status]');
    status.textContent = visible ? visible + ' ' + status.dataset.countLabel : status.dataset.empty;
  }
  function useIndustryHash() {
    const root = document.querySelector('[data-lanotec-browser]');
    if (!root) return;
    const option = Array.from(root.querySelector('[data-browse-industry]').options).find(option => '#' + option.dataset.anchor === window.location.hash);
    if (option) {
      root.querySelector('[data-browse-mode]').value = 'industry';
      root.querySelector('[data-browse-industry]').value = option.value;
      updateBrowser(root);
    }
  }
  function initBrowsers() {
    document.querySelectorAll('[data-lanotec-browser]').forEach(root => {
      root.querySelector('[data-browse-controls]').hidden = false;
      updateBrowser(root);
    });
    useIndustryHash();
  }
  document.addEventListener('change', event => {
    if (!(event.target instanceof HTMLSelectElement)) return;
    const root = event.target.closest('[data-lanotec-browser]');
    if (!root) return;
    if (event.target.matches('[data-browse-mode], [data-browse-industry], [data-browse-type]')) {
      updateBrowser(root);
      return;
    }
    if (!event.target.matches('[data-browse-size]')) return;
    updateCard(event.target.closest('[data-browse-card]'));
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-browse-product-link], [data-browse-image-link]');
    const card = link?.closest('[data-browse-card]');
    const select = card?.querySelector('[data-browse-size]');
    if (select && !select.value) { event.preventDefault(); select.focus(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBrowsers); else initBrowsers();
  window.addEventListener('hashchange', useIndustryHash);
  document.addEventListener('shopify:section:load', initBrowsers);
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('[data-browse-card]');
    const root = card?.closest('[data-lanotec-browser]');
    if (root) { root.querySelector('[data-browse-mode]').value = 'all'; updateBrowser(root); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lanotec-stockist-search"] && !Shopify.designMode) return;
  try {
    
if (!window.lanotecStockistDirectory) {
  window.lanotecStockistDirectory = true;
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  function initStockists() {
    const root = document.querySelector('[data-stockist-search]');
    if (!root) return;
    const controls = root.querySelector('[data-stockist-controls]');
    const query = root.querySelector('[data-stockist-query]');
    const region = root.querySelector('[data-stockist-region]');
    const company = root.querySelector('[data-stockist-company]');
    const status = root.querySelector('[data-stockist-status]');
    const groups = Array.from(document.querySelectorAll('[data-stockist-group]'));
    const cards = Array.from(document.querySelectorAll('[data-stockist-card]'));
    function options(select, values) {
      const previous = select.value;
      while (select.options.length > 1) select.remove(1);
      Array.from(new Set(values.filter(Boolean))).sort((a,b) => a.localeCompare(b, 'en-NZ')).forEach(value => select.add(new Option(value,value)));
      select.value = previous;
      if (select.selectedIndex < 0) select.selectedIndex = 0;
    }
    options(region, cards.map(card => card.dataset.region));
    options(company, groups.map(group => group.dataset.stockistGroup));
    function filter() {
      const terms = normalize(query.value).split(/\s+/).filter(Boolean);
      let visible = 0;
      groups.forEach(group => {
        let groupCount = 0;
        group.querySelectorAll('[data-stockist-card]').forEach(card => {
          const search = normalize(card.dataset.search || '');
          const matches = terms.every(term => search.includes(term)) && (!region.value || card.dataset.region === region.value) && (!company.value || group.dataset.stockistGroup === company.value);
          card.hidden = !matches;
          if (matches) { groupCount++; visible++; }
        });
        group.hidden = groupCount === 0;
      });
      status.textContent = visible ? visible + ' ' + status.dataset.countLabel : status.dataset.empty;
    }
    query.oninput = filter;
    region.onchange = filter;
    company.onchange = filter;
    root.querySelector('[data-stockist-reset]').onclick = () => { query.value = ''; region.value = ''; company.value = ''; filter(); query.focus(); };
    controls.hidden = false;
    root.resetDirectory = () => { query.value=''; region.value=''; company.value=''; filter(); };
    filter();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStockists); else initStockists();
  document.addEventListener('shopify:section:load', initStockists);
  document.addEventListener('shopify:section:unload', () => setTimeout(initStockists, 0));
  document.addEventListener('shopify:section:reorder', initStockists);
  document.addEventListener('shopify:block:select', event => {
    if (event.target.closest('[data-stockist-card]')) document.querySelector('[data-stockist-search]')?.resetDirectory?.();
  });
}

  } catch(e) { console.error(e); }
})();
})();
